import { PageHeaderWrapper } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { WrappedNavigationButton } from "./components/WrappedNavigationButton";
import { WrappedProgressBar } from "./components/WrappedProgressBar";
import { type NavigationVariant } from "./Insight/getNavigationVariant";

interface CbhWrappedHeaderProps {
  currentStep: number;
  lastInsightIndex: number;
  variant: NavigationVariant;
  onNext: () => void;
  onPrevious: () => void;
}

export function CbhWrappedHeader(props: CbhWrappedHeaderProps) {
  const { currentStep, lastInsightIndex, variant, onNext, onPrevious } = props;

  return (
    <PageHeaderWrapper
      sx={(theme) => ({
        position: "absolute",
        top: 0,
        left: theme.spacing(5),
        right: theme.spacing(5),
        zIndex: 1000,
        background: "transparent",
      })}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ gap: 4 }}>
        <WrappedNavigationButton
          direction="previous"
          variant={variant}
          disabled={currentStep === 0}
          onClick={onPrevious}
        />
        <WrappedProgressBar completed={currentStep} total={lastInsightIndex} variant={variant} />
        <WrappedNavigationButton
          direction="next"
          variant={variant}
          disabled={currentStep === lastInsightIndex}
          onClick={onNext}
        />
      </Stack>
    </PageHeaderWrapper>
  );
}
